interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

/**
 * Exact "Vector" dropdown-caret asset from the Dashboard header Figma frame (76184:5977).
 * Figma renders this asset with a 180deg rotation to point down — the path below is
 * pre-flipped (apex at bottom) so it points down natively without a CSS transform.
 */
const FigmaTriangleDown = ({ width = 10, height = 6, color = '#8B5CF6' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 10 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M5.00001 6L10 0H0L5.00001 6Z' fill={color} />
    </svg>
  );
};

export default FigmaTriangleDown;
